import { words } from 'lodash';

const MAX_RESPONSE_WORDS = 5000;
export const MAX_ROWS_PER_BLOCK = 200;
export const TRUNCATION_NOTICE = `...\n\n***\n\nThis response was limited to ${MAX_RESPONSE_WORDS.toLocaleString()} words.`;
export const INPUT_TRUNCATION_NOTE = `\n\nNote: some data sources exceeded the ${MAX_ROWS_PER_BLOCK}-entry limit; only the first ${MAX_ROWS_PER_BLOCK} entries were processed.`;

const countWords = (text: string): number => words(text).length;

export const sliceToWords = (text: string, wordLimit: number): string => {
  if (wordLimit <= 0) return text;
  const ws = words(text);
  if (ws.length <= wordLimit) return text;
  let length = wordLimit;
  for (let i = 0; i < wordLimit; i++) length += ws[i]!.length;
  return text.substring(0, length).trimEnd();
};

export const createWordBudget = () => {
  let used = 0;
  let capped = false;

  return (chunk: string): string | null => {
    if (capped) return null;
    const chunkWords = countWords(chunk);
    if (used + chunkWords <= MAX_RESPONSE_WORDS) {
      used += chunkWords;
      return chunk;
    }
    capped = true;
    return sliceToWords(chunk, MAX_RESPONSE_WORDS - used) + TRUNCATION_NOTICE;
  };
};
